

















































































































































































// @ts-nocheck
import TimeEntryForm from '@/components/TimeEntryForm.vue';
import {caption} from '@/filters/caption';
import axios from 'axios';

export default {
  components: {
    TimeEntryForm
  },
  data() {
    return {
      showBilled: true,
      items: [] as any[],
      users: [] as any[],
      clients: [] as any[],
      isSearching: false,
      type: 'day',
      isShowEntryForm: false,
      isShowStartDateMenu: false,
      calendarStart: '',
      ready: false,
      isShowSelected: false,
      selectedEntry: null,
      selectedElement: null,
      types: [
        'month',
        'week',
        'day'
      ],
      viewOptions: [
        {
          title: caption('Day'),
          type: 'day'
        },
        {
          title: caption('Week'),
          type: 'week'
        },
        {
          title: caption('Month'),
          type: 'month'
        },
      ],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      workTypes: [] as any[],
      calendarModel: '',
      events: [] as any[],
      colors: ['blue',
        'indigo darken-2',
        'deep-purple darken-2',
        'cyan darken-2',
        'orange darken-2',
        'indigo darken-2',
        'teal darken-2',
        'green darken-2',
        'lime darken-2',
        'light-green darken-2',
        'amber darken-2',
        'brown',
        'blue-grey',
        'grey darken-1',
        'red'
      ],
      names: ['Meeting',
        'Holiday',
        'PTO',
        'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      startDate: new Date().toISOString().substr(0, 10),
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10),
      interval: null,
      employeeColors: {} as any
    }
  },
  async beforeMount() {
    await this.getUsers();
    await this.getClients();
    await this.getWorkTypes();
    this.refresh();
  },
  async mounted() {
    this.$store.commit('TITLE_BAR', caption("Calendar"));

    this.ready = true;
    this.scrollToTime();

    this.interval = setInterval(this.refresh, 30 * 1000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  computed: {
    cal(): any | null {
      return this.ready ? this.$refs.calendar : null
    },
    nowY(): string {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
    }
  },
  methods: {
    showTimeEntryForm() {
      this.isShowSelected = false;
      this.isShowEntryForm = true;
    },
    showEvent ({ nativeEvent, event }) {
      console.log("showEvent", event);
      const open = () => {
        this.selectedEntry = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.isShowSelected = true))
      }

      if (this.isShowSelected) {
        this.isShowSelected = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    async prev() {
      // decrement startDate by 1
      const date = new Date(this.startDate);
      date.setDate(date.getDate() - 1);
      this.startDate = date.toISOString().substr(0, 10);
      this.$refs.calendar.prev()
    },
    async next() {
      const date = new Date(this.startDate);
      date.setDate(date.getDate() + 1);
      this.startDate = date.toISOString().substr(0, 10);
      this.$refs.calendar.next()
    },
    toggleBilled() {
      this.showBilled = !this.showBilled;
      this.refresh();
    },
    getCurrentTime () {
        return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
    },
    scrollToTime () {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)

      this.cal.scrollToTime(first)
    },
    updateTime() {
      // setInterval(() => this.cal.updateTimes(), 60 * 1000)
    },
    setStartDate() {
      (this.$refs.menu as any).save(this.startDate);
    },
    async getEvents({ start, end }) {
      const events = [];
      this.start = start;
      this.end = end;

      await this.getItems(start, end);
      
      for (const entry of this.items) {
        const allDay = false;
        const start = new Date(entry.started_at);
        let end: Date | null = new Date(entry.ended_at);

        if (!entry.ended_at) {
          end = new Date();
        }

        const employee = this.users.find(x => x.id === entry.employee_id);
        let title = employee ? employee.full_name : 'Unassigned';
        const client = this.clients.find(x => x.id === entry.client_id);

        title += ` (${client.name}`
        if (entry.project) {
          title += `-${entry.project})`;
        } else {
          title += `)`;
        }

        let color = this.employeeColors[entry.employee_id] || 'grey';

        if (!entry.ended_at) {
          color = 'grey lighten-2';
        }

        if (entry.billed_at) {
          color = 'green lighten-2';

          title += ' (Billed)';
        }

        events.push({
          name: title,
          start,
          end,
          color,
          timed: !allDay,
          billed: entry.billed_at,
          employee_id: entry.employee_id,
          data: entry
        });
      }

      this.events = events;
    },
    refresh() {
      this.getEvents({
        start: this.start, 
        end: this.end
      });
    },
    getEventColor(event: any) {
      return event.color;
    },
    changeView(view: any) {
      this.type = view.type;
    },
    async getUsers() {
      try {
        const result = await axios.get(`/users`);
        this.users = result.data;

        for (const i in this.users) {
          const employee = this.users[i];
          this.employeeColors[employee.id] = this.colors[i];
        }
      } catch (e) {
        console.error(e);
      }
    },
    getUser(id: any) {
      try {
        const user = this.users.find(x => x.id === id);
        return user ? user.full_name : id;
      } catch (e) {
        return id;
      }
    },
    async getWorkTypes() {
      try {
        const result = await axios.get('/settings');
        this.workTypes = result.data.work_types;
      } catch (e) {
        console.error(e);
      }
    },
    getWorkType(id: any) {
      try {
        const workType = this.workTypes.find(x => x.id === id);
        return workType ? workType.name : id;
      } catch (e) {
        return id;
      }
    },
    async getClients() {
      try {
        const result = await axios.get('/clients');
        this.clients = result.data;
      } catch (e) {
        console.error(e);
      }
    },
    getClient(id: any) {
      try {
        const client = this.clients.find(x => x.id === id);
        return client ? client.name : id;
      } catch (e) {
        return id;
      }
    },
    async getItems(start: any, end: any) {
      if (this.isSearching) {
        return;
      }

      this.items = [];
      this.isSearching = true;

      const showBilled = this.showBilled ? '&showBilled=true' : '';

      try {
        const result = await axios.get(`/time-entries/filter?start=${start.date}&end=${end.date}${showBilled}`);
        this.items = result.data;
      } catch (e) {
        console.error(e);
      }

      this.isSearching = false;
    }
  }
}
